function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  stroke: "currentColor",
  d: "M16 1C7.716 1 1 7.257 1 14.975c0 4.398 2.181 8.321 5.59 10.883v5.328l5.107-2.82c1.363.38 2.807.584 4.303.584 8.284 0 15-6.257 15-13.975S24.284 1 16 1z"
}), React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M17.49 19.82l-3.82-4.1-7.453 4.1 8.2-8.758 3.912 4.1 7.36-4.1z"
}), React.createElement("path", {
  d: "M0 0h32v32H0z"
}));

const SvgMessenger = props => React.createElement("svg", _extends({
  viewBox: "0 0 32 32"
}, props), _ref);

export default __webpack_public_path__ + "static/media/messenger.2b0736a4.svg";
export { SvgMessenger as ReactComponent };